import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guard';

const routes: Routes = [
  {path: '' ,  loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule)},
  {path: 'cards' ,  loadChildren: () => import('./components/cards/cards.module').then(m => m.CardsModule), canActivate: [AuthGuard]},
  {path: 'deposits' ,  loadChildren: () => import('./components/deposits/deposits.module').then(m => m.DepositsModule),
    canActivate: [AuthGuard]},
  {path: 'karpooshe', loadChildren: () => import('./components/karpooshe/karpooshe.module').then(m => m.KarpoosheModule),
    canActivate: [AuthGuard]},
  {path: 'cheque', loadChildren: () => import('./components/cheque/cheque.module').then(m => m.ChequeModule), canActivate: [AuthGuard]},
  {path: 'financial', loadChildren: () => import('./components/financial/financial.module').then(m => m.FinancialModule),
    canActivate: [AuthGuard]},
  // tslint:disable-next-line:max-line-length
  {path: 'utilities', loadChildren: () => import('./components/utilities/utilities.module').then(m => m.UtilitiesModule), canActivate: [AuthGuard]},
  {path: 'receipt', loadChildren: () => import('./components/receipt/receipt.module').then(m => m.ReceiptModule)},
  {path: 'setting', loadChildren: () => import('./components/setting/setting.module').then(m => m.SettingModule)},
  {path: 'notification/:id', loadChildren: () => import('./components/notif/notif.module').then(m => m.NotifModule)},
  {path: '**' ,  loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule)}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
